import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";

export default function FileDropzone({ onFiles, accept, multiple = true, testid, title, hint, capture }) {
  const [over, setOver] = useState(false);
  const input = useRef(null);
  const handle = (list) => {
    const files = Array.from(list || []);
    if (files.length) onFiles(files);
  };
  return (
    <div
      data-testid={testid}
      onClick={() => input.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        handle(e.dataTransfer.files);
      }}
      className={`cursor-pointer border-2 border-dashed border-[#383838] rounded-md p-6 text-center bg-[#121212] transition-colors hover:border-[#555] ${over ? "drop-active" : ""}`}
    >
      <UploadCloud className="mx-auto mb-2 text-[#E50914]" size={28} />
      <div className="text-sm font-semibold text-white">{title}</div>
      {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
      <input
        ref={input}
        type="file"
        hidden
        accept={accept}
        multiple={multiple}
        capture={capture}
        data-testid={`${testid}-input`}
        onChange={(e) => {
          handle(e.target.files);
          e.target.value = "";
        }}
      />
    </div>
  );
}
